
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import HttpUtil from "@/assets/js/HttpUtil";
import { StoreTypes } from "@/assets/js/Types";
import Urls from "@/assets/js/Urls";
import Utils from "@/assets/js/Utils";
import BoxCom from "@/components/BoxCom.vue";
import MapCom from "@/components/MapCom.vue";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      currentDt: "",
      deviceDetail: {} as any,
      project: {} as any,
      sid: null as any,
      deviceLoading: false,
      currentSid: null as any,
      urlData: null as any,
      detail: null as any,
      logLoading: false,
      logs: [] as any,
      current: null as any,
      map: null as any,
      lines: [] as any[],
      mapIconPointer: require("@/assets/img/map/pointer.png"),
      carIconPointer: require("@/assets/img/map/icon_car2.png"),
      dts: Utils.getPast30DayList(),
    };
  },
  components: { BoxCom, MapCom },
  async mounted() {
    this.map = this.$refs.mapCom;
    this.map.init(true);
    this.project = this.$store.state.project[StoreTypes.XC_PROJECT_CURRENT];
    this.sid = this.$route.query.sid;
    this.getDeviceDetail();
    await this.getLog();
  },
  methods: {
    async getLog() {
      this.logLoading = true;
      let req: any = await Utils.GetPageReq(1, 1000, null, []);
      req.conditions = [];
      req.conditions.push({
        field: "deviceSid",
        value: this.sid,
        conditionType: 0,
      });
      req.orderByConditions = [];
      req.orderByConditions.push({
        field: "checkInTime",
        asc: false,
      });
      const ret: any = await HttpUtil.XCHttpPost(Urls.GetEnvCarLog, req, true, true);

      this.logLoading = false;
      this.logs = ret.data;
      console.log(this.logs);
    },
    payLog() {
      if (!this.currentDt) {
        throw "请选择回放日期";
      }
      this.map.playLog(this.lines, this.carIconPointer, { w: 26, h: 60 });
    },
    async getNDetail() {
      const ret: any = await HttpUtil.XCHttpPost(
        this.urlData.getUrl,
        this.sid,
        true,
        false
      );
      this.detail = ret;
      if (this.detail.point) {
        this.initMap();
      }
    },
    drawPolcy(data: any[], moveData?: any) {
      const map: any = this.$refs.mapCom;
      map.drawPolyLine(data, moveData);
    },
    initMap() {
      this.current = this.detail.point;
      this.map.setCenter(this.current.lat, this.current.lng);
      this.map.removePolyLine();
      this.map.clearDevice(6);
      this.lines = [];
      this.lines = JSON.parse(this.current.workLines);
      if (this.lines && this.lines.length > 0) {
        this.drawPolcy(this.lines);
      }
      if (this.current.pointers && this.current.pointers.length > 0) {
        this.current.pointers.forEach((x: any) => {
          this.map.addMarker(
            this.current.pointers,
            this.mapIconPointer,
            { w: 50, h: 65 },
            6
          );
        });
      }
    },
    async getDeviceDetail() {
      this.deviceLoading = true;
      const ret: any = await DeviceRequestBill.GetDeviceDetail(this.sid, true);
      if (ret && ret.data && ret.data.length == 1) {
        this.deviceDetail = ret.data[0];
        this.currentSid = this.deviceDetail.categorySid;
        this.urlData = Utils.getActionUrl(this.currentSid + "");
        await this.getNDetail();
      }
      this.deviceLoading = false;
    },
  },
});
